"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
require("babel-polyfill");
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _elements = require("@reservamos/elements");
var _App = _interopRequireDefault(require("@/components/App"));
var _react2 = require("@sentry/react");
var _GrowthBookProvider = _interopRequireDefault(require("@/components/GrowthBookProvider"));
var _mercadoPago = require("@/components/mercadoPago");
var _OpenPayLoader = _interopRequireDefault(require("@/components/OpenPayLoader"));
var _CSSVariablesProvider = _interopRequireDefault(require("@/components/CSSVariablesProvider/CSSVariablesProvider"));
var _defaultEnvs = _interopRequireDefault(require("@/config/defaultEnvs"));
var _LoyaltyProgramsProvider = _interopRequireDefault(require("./loyalty/context/LoyaltyProgramsProvider"));
var _CustomI18nextProvider = _interopRequireDefault(require("./CustomI18nextProvider"));
var _taplytics = require("./utils/taplytics");
var _initializers = _interopRequireDefault(require("./initializers"));
var _fetchWhitelabelConfig = _interopRequireDefault(require("./api/fetchWhitelabelConfig"));
require("@/vendor");
require("@/styles/theme/_design-system.scss");
require("@/styles/main.scss");
require("@/tailwind.css");
var _TranslatedErrorFallback = _interopRequireDefault(require("./errorMonitoring/TranslatedErrorFallback"));
var _errorMonitoring = _interopRequireDefault(require("./errorMonitoring"));
var _ReserhubAccount = require("./context/ReserhubAccount");
var _GontijoSession = require("./context/GontijoSession");
var _CdsFrequentPassenger = require("./context/CdsFrequentPassenger");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Initialize Sentry as early as possible
if (_defaultEnvs["default"] !== null && _defaultEnvs["default"] !== void 0 && _defaultEnvs["default"].sentry) {
  _errorMonitoring["default"].init(_defaultEnvs["default"].sentry);
}

/**
 * Initializes the application by loading whitelabel configuration and client services.
 */
function AppLoader() {
  var _config$env$shared;
  // eslint-disable-next-line no-unused-vars
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    config = _useState4[0],
    setConfig = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    store = _useState6[0],
    setStore = _useState6[1];
  (0, _react.useEffect)(function () {
    /**
     * Initializes application configuration and client services.
     */
    function init() {
      return _init.apply(this, arguments);
    }
    function _init() {
      _init = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _whitelabelConfig$env, whitelabelConfig, _yield$initializeClie, storeInstance, taplytics, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _fetchWhitelabelConfig["default"])();
            case 1:
              whitelabelConfig = _context.sent;
              _context.next = 2;
              return (0, _initializers["default"])(whitelabelConfig);
            case 2:
              _yield$initializeClie = _context.sent;
              storeInstance = _yield$initializeClie.storeInstance;
              if ((_whitelabelConfig$env = whitelabelConfig.env.taplytics) !== null && _whitelabelConfig$env !== void 0 && _whitelabelConfig$env.enabled) {
                taplytics = (0, _taplytics.getInstance)();
                taplytics.propertiesLoaded(function () {
                  setConfig(whitelabelConfig);
                  setStore(storeInstance);
                });
              } else {
                setConfig(whitelabelConfig);
                setStore(storeInstance);
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](0);
              // Force an error that React can render
              setError(function () {
                throw _t;
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 3]]);
      }));
      return _init.apply(this, arguments);
    }
    init();
  }, []);
  if (!config || !store) return null;
  return /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
    store: store,
    "data-sentry-element": "Provider",
    "data-sentry-component": "AppLoader",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_GrowthBookProvider["default"], {
    "data-sentry-element": "GrowthBookProvider",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_CustomI18nextProvider["default"], {
    "data-sentry-element": "CustomI18nextProvider",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, {
    "data-sentry-element": "BrowserRouter",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_OpenPayLoader["default"], {
    config: _objectSpread(_objectSpread({}, config.env.openPay), {}, {
      openPayRegion: config.features.OPENPAY_REGION
    }),
    "data-sentry-element": "OpenPayLoader",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_mercadoPago.MercadoPagoInstanceProvider, {
    config: config.env.mercadoPago,
    basisTheoryConfig: (_config$env$shared = config.env.shared) === null || _config$env$shared === void 0 ? void 0 : _config$env$shared.basisTheory,
    "data-sentry-element": "MercadoPagoInstanceProvider",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_CSSVariablesProvider["default"], {
    theme: config.env.theme,
    funnelStyle: config.features.FUNNEL_STYLE,
    funnelStyleBrandVariation: config.env.brand.toUpperCase(),
    "data-sentry-element": "CSSVariablesProvider",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_elements.ThemeProvider, {
    theme: config.env.theme,
    "data-sentry-element": "ThemeProvider",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_LoyaltyProgramsProvider["default"], {
    "data-sentry-element": "LoyaltyProgramsProvider",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_ReserhubAccount.ReserhubAccountProvider, {
    "data-sentry-element": "ReserhubAccountProvider",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_GontijoSession.GontijoSessionProvider, {
    "data-sentry-element": "GontijoSessionProvider",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_CdsFrequentPassenger.CdsFrequentPassengerProvider, {
    "data-sentry-element": "CdsFrequentPassengerProvider",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_App["default"], {
    "data-sentry-element": "App",
    "data-sentry-source-file": "index.tsx"
  })))))))))))));
}
(0, _reactDom.render)(/*#__PURE__*/_react["default"].createElement(_react2.ErrorBoundary, {
  beforeCapture: function beforeCapture(scope) {
    scope.setTag('fallbackScreen', true);
  },
  fallback: function fallback(_ref) {
    var resetError = _ref.resetError,
      error = _ref.error;
    return /*#__PURE__*/_react["default"].createElement(_TranslatedErrorFallback["default"], {
      resetError: resetError,
      error: error
    });
  }
}, /*#__PURE__*/_react["default"].createElement(AppLoader, null)), document.getElementById('app'));